import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from 'environments/environment';
import { EnvironmentTypeEnum } from 'environments/environment-type.enum';

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function B2CPolicies() {
  const ex = new SitesData().getCurrentSite();
  return {
    names: {
      signUpSignIn: ex.mainPolicyName,
      forgotPassword: ex.resetPswPolicyName
    },
    scope: ex.scope,
    authorities: {
      signUpSignIn: {
        authority: ex.mainAuthority
      },
      forgotPassword: {
        authority: ex.resetPswAuthority
      }
    },
    authorityDomain: ex.domain
  };
}

export function MSALConfig(): Configuration {
  const ex = new SitesData().getCurrentSite();
  return {
    auth: {
      clientId: ex.clientId,
      authority: ex.mainAuthority,
      knownAuthorities: [ex.domain],
      redirectUri: location.origin
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      loggerOptions: {
        loggerCallback: (logLevel, message, containsPii) => {
          //
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    }
  };
}

export class SitesData {
  data: SiteDataItem[];

  constructor() {
    this.data = [
      // {
      //   site: 'localhost:4200',
      //   mainPolicyName: 'b2c_1_signup-alby',
      //   resetPswPolicyName: 'b2c_1_signup-alby_reset',
      //   domain: 'orbytab2c.b2clogin.com',
      //   clientId: 'caf71e3b-65e0-4f06-b9dc-ee800a47e37d',
      //   scope: 'openid profile email caf71e3b-65e0-4f06-b9dc-ee800a47e37d',
      //   mainAuthority: 'https://orbytab2c.b2clogin.com/orbytab2c.onmicrosoft.com/b2c_1_signup-alby',
      //   resetPswAuthority: 'https://orbytab2c.b2clogin.com/orbytab2c.onmicrosoft.com/b2c_1_signup-alby',
      //   environmentType: EnvironmentTypeEnum.local
      // },
      {
        site: 'localhost:4200',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspab2c.b2clogin.com',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.local
      },
      // {
      //   //prod
      //   site: 'localhost:4200',
      //   mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
      //   resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
      //   domain: 'basicnetspa4shop.b2clogin.com',
      //   clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
      //   scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
      //   mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
      //   resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
      //   environmentType: EnvironmentTypeEnum.local
      // },
      {
        site: '4shop-dev.kappa.com',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspab2c.b2clogin.com',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.staging
      },
      {
        site: '4shop-dev.kappa.es',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspab2c.b2clogin.com',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.staging
      },
      {
        site: '4shop-dev.superga.com',
        mainPolicyName: 'B2C_1A_SUPERGA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_SUPERGA4SHOP_PASSWORDRESET',
        domain: 'basicnetspab2c.b2clogin.com',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_SUPERGA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_SUPERGA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.staging
      },
      {
        site: '4shop-dev.robedikappa.com',
        domain: 'basicnetspab2c.b2clogin.com',
        mainPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        environmentType: EnvironmentTypeEnum.staging
      },
      {
        site: '4team-dev.kappa.com',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspab2c.b2clogin.com',
        mainAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspab2c.b2clogin.com/basicnetspab2c.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        clientId: '2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        scope: 'openid profile email 2c8f5cfb-6970-4ca9-9e26-82ba8d7a8c6e',
        environmentType: EnvironmentTypeEnum.staging
      },
      {
        site: '4shop.kappa.com',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.superga.com',
        mainPolicyName: 'B2C_1A_SUPERGA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_SUPERGA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_SUPERGA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_SUPERGA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.k-way.com',
        mainPolicyName: 'B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KWAY4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.sebago.com',
        mainPolicyName: 'B2C_1A_SEBAGO4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_SEBAGO4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_SEBAGO4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_SEBAGO4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.briko.com',
        mainPolicyName: 'B2C_1A_BRIKO4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_BRIKO4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_BRIKO4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_BRIKO4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.robedikappa.com',
        mainPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4team.kappa.com',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4team.k-way.com',
        mainPolicyName: 'B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KWAY4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.kappa.es',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.kappa.fr',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4team.kappa.es',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.robedikappa.es',
        mainPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4team.kappa.fr',
        mainPolicyName: 'B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.robedikappa.fr',
        mainPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_ROBEDIKAPPA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.culuccia.com',
        mainPolicyName: 'B2C_1A_CULUCCIA4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_CULUCCIA4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_CULUCCIA4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_CULUCCIA4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
      {
        site: '4shop.k-way.fr',
        // site: 'retail.k-way.com',
        mainPolicyName: 'B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswPolicyName: 'B2C_1A_KWAY4SHOP_PASSWORDRESET',
        domain: 'basicnetspa4shop.b2clogin.com',
        clientId: '7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        scope: 'openid profile email 7a558dcb-48a4-4960-a4ee-9d7cfa65549a',
        mainAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_SIGNUP_SIGNIN',
        resetPswAuthority: 'https://basicnetspa4shop.b2clogin.com/basicnetspa4shop.onmicrosoft.com/B2C_1A_KWAY4SHOP_PASSWORDRESET',
        environmentType: EnvironmentTypeEnum.production
      },
    ];
  }

  public getCurrentSite() {
    return (this.data || []).find(x => window.location.origin.indexOf(x.site) >= 0 && x.environmentType === environment.environmentType);
  }
}

export class SiteDataItem {
  site: string;
  environmentType: EnvironmentTypeEnum;
  domain: string;
  mainPolicyName: string;
  resetPswPolicyName: string;
  clientId: string;
  scope: string;
  resetPswAuthority: string;
  mainAuthority: string;
}
